import notification from "antd/lib/notification";
import "antd/lib/notification/style/css";

export default notification;
